export const dataTable = [
    {
      id: 4,
      name: 'Patricia Lebsack',
      email: 'Julianne.OConner@kory.org',
      passed: 'Sí',
      file: '<a href="http://www.google.com">Google</a>',
      button: 'Button #1',
    },
    {
      id: 5,
      name: 'Chelsey Dietrich',
      email: 'Lucio_Hettinger@annie.ca',
      passed: 'No',
      file: '<a href="http://www.google.com">Google</a>',
      button: 'Button #2',
    },
    {
      id: 6,
      name: 'Mrs. Dennis Schulist',
      email: 'Karley_Dach@jasper.info',
      passed: 'Sí',
      file: '<a href="http://www.google.com">Google</a>',
      button: 'Button #3',
    },
    {
      id: 7,
      name: 'Kurtis Weissnat',
      email: 'Telly.Hoeger@billy.biz',
      passed: 'No',
      file: '<a href="http://www.google.com">Google</a>',
      button: 'Button #4',
    },
    {
      id: 8,
      name: 'Nicholas Runolfsdottir V',
      email: 'Sherwood@rosamond.me',
      passed: 'Sí',
      file: '<a href="http://www.google.com">Google</a>',
      button: 'Button #5',
    },
    {
      id: 9,
      name: 'Glenna Reichert',
      email: 'Chaim_McDermott@dana.io',
      passed: 'No',
      file: '<a href="http://www.google.com">Google</a>',
      button: 'Button #6',
    },
    {
      id: 10,
      name: 'Clementina DuBuque',
      email: 'Rey.Padberg@karina.biz',
      passed: 'No',
      file: '<a href="http://www.google.com">Google</a>',
      button: 'Button #7',
    },
    {
      id: 11,
      name: 'Nicholas DuBuque',
      email: 'Rey.Padberg@rosamond.biz',
      passed: 'Sí',
      file: '<a href="http://www.google.com">Google</a>',
      button: 'Button #8',
    },
    {
      id: 4,
      name: 'Patricia Lebsack',
      email: 'Julianne.OConner@kory.org',
      passed: 'Sí',
      file: '<a href="http://www.google.com">Google</a>',
      button: 'Button #1',
    },
    {
      id: 5,
      name: 'Chelsey Dietrich',
      email: 'Lucio_Hettinger@annie.ca',
      passed: 'No',
      file: '<a href="http://www.google.com">Google</a>',
      button: 'Button #2',
    },
    {
      id: 6,
      name: 'Mrs. Dennis Schulist',
      email: 'Karley_Dach@jasper.info',
      passed: 'Sí',
      file: '<a href="http://www.google.com">Google</a>',
      button: 'Button #3',
    },
    {
      id: 7,
      name: 'Kurtis Weissnat',
      email: 'Telly.Hoeger@billy.biz',
      passed: 'No',
      file: '<a href="http://www.google.com">Google</a>',
      button: 'Button #4',
    },
    {
      id: 8,
      name: 'Nicholas Runolfsdottir V',
      email: 'Sherwood@rosamond.me',
      passed: 'Sí',
      file: '<a href="http://www.google.com">Google</a>',
      button: 'Button #5',
    },
    {
      id: 9,
      name: 'Glenna Reichert',
      email: 'Chaim_McDermott@dana.io',
      passed: 'No',
      file: '<a href="http://www.google.com">Google</a>',
      button: 'Button #6',
    },
    {
      id: 10,
      name: 'Clementina DuBuque',
      email: 'Rey.Padberg@karina.biz',
      passed: 'No',
      file: '<a href="http://www.google.com">Google</a>',
      button: 'Button #7',
    },
    {
      id: 11,
      name: 'Nicholas DuBuque',
      email: 'Rey.Padberg@rosamond.biz',
      passed: 'Sí',
      file: '<a href="http://www.google.com">Google</a>',
      button: 'Button #8',
    },
  ];



// WEBPACK FOOTER //
// ./src/app/examples/data-table/shared/data.service.ts